import { createGlobalStyle } from 'styled-components'
import theme from 'config/theme'

const GlobalStyle = createGlobalStyle`
    * {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline: none;

      &::before,
      &::after {
        box-sizing: border-box;
      }
    }
    
    html, body, #root {
      min-height: 100vh;
      background-color: ${theme.colors.wildSand};
    }
    
    input {
      -webkit-box-shadow: inset 0 0 0px 9999px transparent;
    }
  
    @-ms-viewport{
      width: device-width;
    }

    .Toastify__toast--default {
      box-shadow: none !important;
      background: transparent !important;
    }
  `

export default GlobalStyle
